<template>
  <div
    :style="{width: (state.fullScreen ? '100%' : player.width)}"
    :class="{'cursor-none': !state.cursorShow && state.fullScreen}"
    class="player">
    <div
      :style="{height: (state.fullScreen ? '100%' : player.height)}"
      class="player__video-wrap">
      <div class="player__video">
        <video
          :poster="options.poster" :loop="options.loop"
          @click="play">您的浏览器不支持此播放器</video>
      </div>
    </div>
    <div
      v-show="state.contrlShow || !state.fullScreen"
      :class="{'fix-bottom': state.fullScreen}"
      class="player__video-control">
      <!-- 播放/暂停按钮 -->
      <div class="player__video-btn player__video-btn-start" @click="play">
        <t-icon v-if="!state.playing" class="aid-play" size="24"></t-icon>
        <t-icon v-else class="aid-pause" size="24"></t-icon>
      </div>
      <!-- 播放进度条 -->
      <div class="player__video-progress" @click.left="$_onSlideDivClick" @mousedown.left="onVideoMoveDivClick">
        <div class="player__video-progress-bar pui-slider">
          <div class="pui-slider__tracker-wrp">
            <div class="pui-slider__tracker">
              <!-- 缓冲进度 -->
              <div class="player__video-progress-buffer">
                <div :style="{width: video.loaded + '%'}" class="player__video-progress-buffer__range"></div>
              </div>
              <!-- 进度按钮 -->
              <div :style="{left: video.pos.current + 'px'}" class="pui-slider__handle"></div>
              <!-- 播放进度 -->
              <div :style="{width: video.pos.current + 'px'}" class="pui-slider__progress"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 播放时间 -->
      <div class="player__video-time">
        <div class="video-time-wrap">
          <span class="video-time-now">{{ video.displayCurrent }}</span>
          <span class="video-divider">/</span>
          <span class="video-time-total">{{ video.displayDuration }}</span>
        </div>
      </div>
      <!-- 声音按钮 -->
      <div class="player__video-btn player__video-volume" @mouseover="$_onVolDivMouseover">
        <div @click.left="$_onVolMutedDivClick">
          <t-icon v-if="!volume.muted && volume.percent >= 66" class="aid-volume-high" size="20"></t-icon>
          <t-icon v-else-if="!volume.muted && volume.percent >= 33" class="aid-volume-medium" size="20"></t-icon>
          <t-icon v-else-if="!volume.muted && volume.percent > 0" class="aid-volume-low" size="20"></t-icon>
          <t-icon v-else-if="volume.muted || volume.percent == 0" class="aid-volume-mute" size="20"></t-icon>
        </div>
        <!-- 音量bar -->
        <div class="player__video-volumebar-wrap">
          <div class="player__video-volume-num">{{ volume.percent }}</div>
          <div class="player__video-volumebar pui-slider pui-slider-vertical" @click.left="$_onVolSlideDivClick" @mousedown.left="$_onVolMoveDivClick">
            <div class="pui-slider__tracker-wrp">
              <div class="pui-slider__tracker">
                <div :style="{bottom: volume.pos.current + 'px'}" class="pui-slider__handle"></div>
                <div :style="{height: volume.pos.current + 'px'}" class="pui-slider__progress"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 全屏按钮 -->
      <div class="player__video-btn player__video-btn-fullScreen" @click="fullScreen">
        <t-icon v-if="!state.fullScreen" class="aid-fullscreen" size="20"></t-icon>
        <t-icon v-else class="aid-fullscreen-exit" size="20"></t-icon>
      </div>
    </div>
  </div>
</template>

<script>
import flvjs from 'flv.js'
// 获得鼠标位置
const getMousePosition = function(e, type = 'x') {
  if (type === 'x') {
    return e.clientX
  }
  return e.clientY
}
// 时间格式化
const pad = val => {
  val = Math.floor(val)
  if (val < 10) {
    return '0' + val
  }
  return val + ''
}
const timeParse = sec => {
  let min = 0
  min = Math.floor(sec / 60)
  sec = sec - min * 60
  return pad(min) + ':' + pad(sec)
}
export default {
  name: 'TVideo',
  props: {
    options: {
      // 配置
      type: Object,
      default() {
        return {
          autoplay: false,
          volume: 0.9,
          poster: '',
          loop: ''
        }
      }
    },
    mediaDataSource: Object,
    config: null
  },
  data() {
    return {
      $video: null, // 视频el
      video: {
        // 视频对象
        $videoSlider: null, // 进度条el
        duration: 0, // 总播放时间
        current: 0, // 当前播放时间
        loaded: 0, // 加载时间
        moving: false, // 是否正在移动
        displayCurrent: '00:00', // 显示的当前时间
        displayDuration: '00:00', // 显示总时间
        pos: {
          // 位置信息
          start: 0, // 起始位置
          width: 0, // 进度条宽度-handel宽度
          handleWidth: 0, // handel宽度
          current: 0 // 当前进度位置
        }
      },
      volume: {
        // 声音对象
        $volSlider: null, // 声音el
        muted: false, // 是否静音
        percent: 60, // 音量百分比
        moving: false, // 是否正在移动
        pos: {
          // 位置信息
          start: 0, // 起始位置
          height: 0, // 进度条高度-handel高度
          handleHeight: 0, // handle位置
          current: 0 // 当前位置
        }
      },
      player: {
        $player: null,
        pos: null
      },
      tmp: {
        // 临时变量
        contrlHideTimer: null // 选项隐藏计时器
      },
      state: {
        // 状态
        contrlShow: true, // 是否显示进度条
        vol: 0.5, // 音量
        currentTime: 0, // 当前时间
        fullScreen: false, // 全屏
        playing: false, // 正在播放
        cursorShow: true // 鼠标是否显示
      }
    }
  },
  // 初始化
  mounted: function() {
    this.$_init()
  },
  beforeDestroy() {
    document.body.removeEventListener('mousemove', this.$_mouseMoveAction)
    document.body.removeEventListener('mouseup', this.$_mouseUpAction)
  },
  methods: {
    // 初始化函数
    $_init() {
      var self = this
      this.$video = this.$el.getElementsByTagName('video')[0] // 获取视频el
      this.flvPlayer = null
      this.flvPlayer = flvjs.createPlayer(
        this.mediaDataSource,
        this.config
          ? this.config
          : {
              enableWorker: false,
              lazyLoadMaxDuration: 3 * 60,
              seekType: 'range'
            }
      )
      this.flvPlayer.attachMediaElement(this.$video)
      this.flvPlayer.load()
      this.$_initCore() // 核心初始化
      if (this.options.autoplay) {
        // 是否自动播放
        this.play()
      }
      document.body.addEventListener('mousemove', this.$_mouseMoveAction, false) // 添加鼠标移动监听
      document.body.addEventListener('mouseup', this.$_mouseUpAction, false) // 添加鼠标按键松开事件
      this.$_initFullScreen(self)
    },
    $_initCore() {
      const vol = this.options.volume || 0.9 // 设置音量 默认0.9
      this.setVol(vol) // 设置音量
      this.$_onVolDivMouseover()
      this.$_initVideo()
      this.$_initPlayer()
    },
    $_onVolDivMouseover() {
      const $volSlider = this.$el.querySelectorAll(
        '.player__video-volumebar .pui-slider__tracker'
      )[0] // 音量盒子-按钮
      const $volHandle = $volSlider.getElementsByClassName(
        'pui-slider__handle'
      )[0] // 音量handle
      this.volume.$volSlider = $volSlider
      this.volume.pos.handleHeight = $volHandle.getBoundingClientRect().height // handle高度
      this.volume.pos.start = $volSlider.getBoundingClientRect().bottom // 音量盒子启示位置
      this.volume.pos.height =
        $volSlider.getBoundingClientRect().height - this.volume.pos.handleHeight // 音量盒子的高度
      this.setVol(this.$video.volume)
    },
    $_initVideo() {
      const $videoSlider = this.$el.getElementsByClassName(
        'player__video-progress'
      )[0] // 进度条wrap
      const $videoHandle = $videoSlider.getElementsByClassName(
        'pui-slider__handle'
      )[0] // 进度条handle
      this.video.$videoSlider = $videoSlider
      this.video.pos.start = $videoSlider.getBoundingClientRect().left
      this.video.pos.handleWidth = $videoHandle.getBoundingClientRect().width
      this.video.pos.width =
        $videoSlider.getBoundingClientRect().width - this.video.pos.handleWidth
      this.$_getTime()
    },
    $_initPlayer() {
      const $player = this.$el // 视频包装player
      this.player.pos = $player.getBoundingClientRect() // 视频包装的位置信息
      this.player.$player = $player
    },
    $_initFullScreen(self) {
      if (document.onwebkitfullscreenchange !== undefined) {
        document.onwebkitfullscreenchange = function() {
          if (document.webkitFullscreenElement) {
            self.state.fullScreen = true
            self.state.contrlShow = true
          } else {
            self.state.fullScreen = false
          }
          setTimeout(self.$_initVideo, 200)
        }
      } else if (document.onmozfullscreenchange !== undefined) {
        document.onmozfullscreenchange = function() {
          if (document.mozFullScreenElement) {
            self.state.fullScreen = true
            self.state.contrlShow = true
          } else {
            self.state.fullScreen = false
          }
          setTimeout(self.$_initVideo, 200)
        }
      } else if (document.MSFullscreenChange !== undefined) {
        document.MSFullscreenChange = function() {
          if (document.msFullscreenElement) {
            self.state.fullScreen = true
            self.state.contrlShow = true
          } else {
            self.state.fullScreen = false
          }
          setTimeout(self.$_initVideo, 200)
        }
      } else {
        document.onfullscreenchange = function() {
          if (document.fullscreenElement) {
            self.state.fullScreen = true
            self.state.contrlShow = true
          } else {
            self.state.fullScreen = false
          }
          setTimeout(self.$_initVideo, 200)
        }
      }
    },
    $_getTime() {
      // 获取时间
      this.$video.addEventListener('durationchange', e => {
        // 视频时长发生变化
      })
      this.$video.addEventListener('progress', e => {
        // 浏览器正在下载视频
        if (this.$video) {
          this.video.loaded =
            this.$video.buffered.end(0) / this.$video.duration * 100 // 已经缓冲的视频长度/总长度 缓冲长度
        }
      })
      this.$video.addEventListener('loadedmetadata', e => {
        this.video.displayDuration = timeParse(this.$video.duration) // 视频长度
        this.video.duration = this.$video.duration
      })
    },
    $_setVideoByTime(percent) {
      this.$video.currentTime = Math.floor(percent * this.video.duration)
    },
    $_onVolMoveDivClick(e) {
      // 点击声音进度条触发
      this.$_onVolDivMouseover()
      this.volume.moving = true
    },
    onVideoMoveDivClick(e) {
      // 点击视频进度条触发
      this.$_initVideo()
      this.video.moving = true
    },
    $_onVolMutedDivClick() {
      // 是否静音
      this.$video.muted = !this.$video.muted
      this.volume.muted = this.$video.muted
    },
    $_timeline() {
      // 进度条变化
      const percent = this.$video.currentTime / this.$video.duration
      this.video.pos.current = (this.video.pos.width * percent).toFixed(3)
      this.video.displayCurrent = timeParse(this.$video.currentTime)
    },
    $_volSlideMove(e) {
      // 音量滑动事件
      const y = this.volume.pos.start - getMousePosition(e, 'y') - 7
      if (y > 0 && y <= this.volume.pos.height) {
        this.setVol(y / this.volume.pos.height)
      } else if (y < 0) {
        this.setVol(0)
      } else if (y > this.volume.pos.height) {
        this.setVol(1)
      }
    },
    $_videoSlideMove(e) {
      // 视频进度条滑动事件
      const x = getMousePosition(e) - this.video.pos.start - 7
      if (x > 0 && x <= this.video.pos.width) {
        this.video.pos.current = x
        this.$_setVideoByTime(x / this.video.pos.width) // 设置当前时间
      } else if (x < 0) {
        this.$_setVideoByTime(0)
      } else if (x > this.video.pos.width) {
        this.$_setVideoByTime(1)
      }
    },
    $_onSlideDivClick(e) {
      this.$_videoSlideMove(e)
    },
    $_onVolSlideDivClick(e) {
      this.$_volSlideMove(e)
    },
    $_mouseMoveAction(e) {
      // 添加鼠标移动监听，如果moving为true则执行移动函数
      if (this.volume.moving) {
        this.$_volSlideMove(e)
      }
      if (this.video.moving) {
        this.$_videoSlideMove(e)
      }
      this.$_contrlHider(e)
    },
    $_mouseUpAction(e) {
      // 鼠标抬起设置moving为false
      this.volume.moving = false
      this.video.moving = false
    },
    $_contrlHider(e) {
      // 控制隐藏
      // const x = getMousePosition(e, 'x')
      const y = getMousePosition(e, 'y')
      if (!this.player.pos) return
      if (this.state.fullScreen) {
        if (y > window.screen.height * 0.8) {
          return this.$_mouseEnterVideo()
        } else {
          return this.$_mouseLeaveVideo()
        }
      }
    },
    $_mouseEnterVideo() {
      // 移进控制栏显示区域 显示控制栏
      if (this.tmp.contrlHideTimer) {
        clearTimeout(this.tmp.contrlHideTimer)
        this.tmp.contrlHideTimer = null
      }
      this.state.contrlShow = true
      this.state.cursorShow = true
    },
    $_mouseLeaveVideo(e) {
      // 移出控制栏显示区域 设置延迟后隐藏控制栏
      if (this.tmp.contrlHideTimer) {
        clearTimeout(this.tmp.contrlHideTimer)
      }
      this.state.cursorShow = true
      this.tmp.contrlHideTimer = setTimeout(() => {
        this.state.contrlShow = false
        this.state.cursorShow = false
        this.tmp.contrlHideTimer = null
      }, 2000)
    },
    destory() {
      this.player.pause()
      this.player.unload()
      this.player.detachMediaElement()
      this.player.destroy()
      this.player = null
    },
    setVol(val) {
      if (this.$video) {
        this.volume.pos.current = val * this.volume.pos.height // 设置音量当前位置
        this.volume.percent = Math.floor(val * 100) // 设置音量百分比
        this.$video.volume = val // 设置视频音量
      }
    },
    play() {
      this.state.playing = !this.state.playing
      if (this.$video) {
        if (this.state.playing) {
          this.$video.play()
          // this.$_mouseLeaveVideo()
          this.$video.addEventListener('timeupdate', this.$_timeline) // 监听播放时时间变化
          this.$video.addEventListener('ended', e => {
            // 监听是否结束
            this.state.playing = false
            this.video.pos.current = 0
            this.$video.currentTime = 0
          })
        } else {
          this.$video.pause()
        }
      }
    },
    fullScreen() {
      if (!this.state.fullScreen) {
        this.state.fullScreen = true
        if (this.player.$player.webkitRequestFullScreen !== undefined) {
          this.player.$player.webkitRequestFullScreen()
        } else if (this.player.$player.mozRequestFullScreen !== undefined) {
          this.player.$player.mozRequestFullScreen()
        } else if (this.player.$player.msRequestFullscreen !== undefined) {
          this.player.$player.msRequestFullscreen()
        } else {
          this.player.$player.requestFullscreen()
        }
      } else {
        this.state.fullScreen = false
        if (document.webkitExitFullscreen !== undefined) {
          document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen !== undefined) {
          document.mozCancelFullScreen()
        } else if (document.mozCancelFullScreen !== undefined) {
          document.msExitFullscreen()
        } else {
          document.exitFullscreen()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// video.vue?41f48aad